import React from 'react';
import { Link as GatsbyLink, navigate } from 'gatsby';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './Link.scss';

const Link = ({ to, href, children, invert, id, ...props }) => {
  // For restricted routes, use onClick navigation to prevent prefetching
  // This avoids 404 errors when Gatsby Link tries to prefetch client-side routes
  // and keeps restricted content secure (not in build artifacts)
  const isRestrictedRoute = to && to.startsWith('/work/restricted/');
  
  return (
    <Choose>
      <When condition={to && isRestrictedRoute}>
        <a
          className={classnames('link', { 'link--invert': invert })}
          href={to}
          onClick={(e) => {
            e.preventDefault();
            navigate(to);
          }}
          {...props}
        >{children}</a>
      </When>
      <When condition={to}>
        <GatsbyLink
          className={classnames('link', { 'link--invert': invert })}
          to={to}
          {...props}
        >{children}</GatsbyLink>
      </When>
      <When condition={href}>
        <a
          className={classnames('link', { 'link--invert': invert })}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
        >{children}</a>
      </When>
      <When condition={id}>
        <a
          className={classnames('link', 'link--id', { 'link--invert': invert })}
          href={id}
        >{children}</a>
      </When>
    </Choose>
  );
}

Link.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]).isRequired,
  href: PropTypes.string,
  to: PropTypes.string,
  id: PropTypes.string
}

export default Link;
